<template>
  <v-container fluid class="grey lighten-3">

    <v-card class="mb-5">

        <v-tabs v-model="tab" @change="tabChanged">
          <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <GoogleBase v-if="tab == 0"></GoogleBase>
          </v-tab-item>
          <v-tab-item>
            <BingBase v-if="tab == 1"></BingBase>
          </v-tab-item>
        </v-tabs-items>

    </v-card>

  </v-container>
</template>

<script>
export default {
  name: 'ContentCreator',

  data () {
    return {
      tab: null,
      items: ['Google', 'Bing'],
      lsTab: 'contentCreator_tab',
    }
  },

  components: {
    BingBase: () => import('@/components/contentCreator/BingBase.vue'),
    GoogleBase: () => import('@/components/contentCreator/GoogleBase.vue'),
  },

  methods: {
    tabChanged () {
      localStorage.setItem(this.lsTab, JSON.stringify(this.tab))
    },
  },

  created: function () {
    if (localStorage.getItem(this.lsTab)) {
      this.tab = JSON.parse(localStorage.getItem(this.lsTab))
    }
  },
}
</script>

<style scoped>
</style>